__turbopack_context__.v({
  "className": "manrope_27accbc5-module__v9aWpa__className",
  "variable": "manrope_27accbc5-module__v9aWpa__variable",
});
